<template>
  <div>
    <FieldLabel :label="label" :tooltip="tooltip" :disabled="disabled" :required="effectiveRequired" :fieldKey="fieldKey" />

    <v-textarea
      v-model="localValue"
      :disabled="disabled"
      :readonly="readonly"
      :required="effectiveRequired"
      :rules="computedRules"
      :maxLength="2000"
      :hide-details="hideDetails ? true : 'auto'"
      color="primary"
      variant="outlined"
      density="comfortable"
      rows="3"
      max-rows="10"
      auto-grow
      :class="['my-textarea', { 'my-textarea--readonly': readonly }]"
      @blur="handleBlur"
    />
  </div>
</template>

<script>
import FieldLabel from "@/components/inputs/FieldLabel.vue";

import { clearMarker } from "@/stores/caseStore/previewMeta";
import * as validationRules from "@/utils/validationRules.js";
import sectionFieldMixin from "@/pages/pageQuestionnaire/base/sectionFieldMixin.js";

export default {
  name: "TextArea",

  mixins: [sectionFieldMixin],

  components: {
    FieldLabel,
  },

  inject: {
    parentKey: { default: null },
    groupId: { default: null },
  },

  props: {
    label: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    clearOnDisable: {
      type: Boolean,
      default: true,
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
      default: "",
    },
    fieldKey: {
      type: String,
      default: "",
    },
  },

  emits: ["update:modelValue", "blur"],

  data() {
    return {
      localValue: this.modelValue,
    };
  },

  watch: {
    modelValue(newValue) {
      this.localValue = newValue;
      clearMarker(this.parentKey, this.groupId, this.fieldKey, this.localValue);
    },

    localValue(newValue) {
      this.$emit("update:modelValue", newValue);
    },

    disabled(newVal) {
      if (newVal && this.clearOnDisable) {
        this.localValue = "";
        this.$emit("update:modelValue", "");
      }
    },
  },

  beforeUnmount() {
    this.localValue = "";
    clearMarker(this.parentKey, this.groupId, this.fieldKey, this.localValue);
    this.$emit("update:modelValue", "");
  },

  computed: {
    computedRules() {
      if (this.readonly) return [];

      const rules = [];

      if (this.effectiveRequired && !this.disabled) {
        rules.push(validationRules.requiredRule());
      }

      return rules;
    },
  },

  methods: {
    handleBlur() {
      if (typeof this.localValue === "string") {
        this.localValue = this.localValue.trim();
      }

      this.$emit("blur");
    },
  },
};
</script>

<style scoped>
.my-textarea :deep(.v-field) {
  border-radius: 8px;
}

.my-textarea :deep(textarea) {
  font-size: 0.9rem;
  padding-left: 12px;
  padding-right: 8px;
  border-radius: 8px;
}

.my-textarea--readonly {
  /* Meeting 27.07.26: kein grauer Hintergrund mehr ("wirkt nicht bearbeitbar"). */
  background-color: transparent;
  pointer-events: none !important;
  user-select: none !important;
}
</style>
